// client/src/modules/support/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Support module manifest (P5)
 *
 * Customer Support - Zendesk-inspired ticketing, call logging.
 * Fully migrated to module registry with lazy-loaded routes.
 */
export const supportModule: ModuleManifest = {
  id: 'P5',
  name: 'Support',
  shortName: 'Support',
  description: 'Support ticketing, call logging, and team collaboration',
  icon: '🎧',
  status: 'live',
  urlPrefix: '/support',
  routes,
  navItems,
};

export default supportModule;
